import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductCard from '../../../components/product/ProductCard';
import _ from 'lodash';
import { fetchMaterial } from '../../../assets/util'
import { load } from '../../../actions/common'

class RelateProductList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            related_products: [],
        };
    }

    componentDidMount() {
        this.fetchProducts();
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.matVarId, this.props.matVarId) ||
            !_.isEqual(prevProps.itemIds, this.props.itemIds)) {
            this.props.load(true)
            this.fetchProducts();
        }
    }

    fetchProducts() {
        // Support both legacy mat_var_id and new item_ids
        if (this.props.matVarId) {
            // Legacy support
            fetchMaterial({ mat_var_id: this.props.matVarId }, null, 1, 4, { wrap: false, sortWithMatVarId: true })
                .then((response) => response.json())
                .then((products) => {
                    this.setState({ related_products: products.data });
                    this.props.load(false);
                })
                .catch(() => {
                    this.props.load(false);
                });
        } else if (this.props.itemIds && this.props.itemIds.length > 0) {
            // New Strapi API support with item_ids
            const itemIds = Array.isArray(this.props.itemIds) ? this.props.itemIds : [this.props.itemIds];

            // Fetch products by item_ids
            Promise.all(itemIds.map(itemId =>
                fetchMaterial({ item_id: itemId }, null, 1, 1, { wrap: false })
                    .then(response => response.json())
                    .then(data => data.data[0])
                    .catch(() => null)
            ))
                .then(products => {
                    const validProducts = products.filter(product => product !== null);
                    this.setState({ related_products: validProducts });
                    this.props.load(false);
                })
                .catch(() => {
                    this.props.load(false);
                });
        }
    }

    render() {
        const { related_products } = this.state
        const { newTab } = this.props
        return (
            _.map(related_products, (product, index) => {
                return <div key={`rp_${index}`} className="col-5 col-md-3">
                    <ProductCard item={product} showWishlist={false} showRating={false} showPromotion={false} lazyLoad={false} showAddToCartText={false} newTab={newTab} />
                </div>
            })
        )
    }
};

function mapStateToProps(state) {
    return {
    }
}
export default connect(mapStateToProps, { load })(RelateProductList)